
import {Component, Prop, Vue, Watch} from 'nuxt-property-decorator'

@Component({
  fetchOnServer: false
})
export default class WebPushPopup extends Vue {
  @Prop() webPushId!: string
  @Prop() webPushUrl!: string
  @Prop() popupComponent!: any
  @Prop() preloaderComponent!: any
  @Prop({
    default: () => ['/', '/by-licence-plate', '/by-sts', '/by-vu', '/by-uin', '/gos-nomer']
  }) routesWhenBeforeLeaveEnabled: string[]

  showPopup: boolean = false
  waitPermission: boolean = false
  isGranted: boolean = false
  showLoader: boolean = false
  browser: string = ''
  beforeLeaveModalShown = false

  async fetch() {
    this.browser = this.$webPush.getBrowser()
  }

  mounted() {
    if (this.$eventBus2) {
      this.$eventBus2.$on('WebPushPermit', this.openPopup)
    } else {
      this.$eventBus.$on('WebPushPermit', this.openPopup)
    }
  }

  openPopup() {
    this.showPopup = true
    this.waitPermission = false
    this.$emit('open')
  }

  closePopup() {
    this.showPopup = false
    this.$emit('closed')
  }

  getPermission() {
    this.waitPermission = true
    let promise!: Promise<any>
    try {
      if ('safari' in window) {
        promise = new Promise((resolve: any) => {
          // @ts-ignore
          window.safari.pushNotification.requestPermission(
            this.webPushUrl,
            this.webPushId,
            {},
            resolve
          )
        }).then((permissionData: any) => {
          if (permissionData.permission !== 'granted') {
            throw new Error('No granted: ' + permissionData.permission)
          }

          return {
            type: 'apns',
            web_push_token: permissionData.deviceToken
          }
        })
      } else {
        promise = this.$fire.messaging.requestPermission().then(async () => {
          let token = await this.$fire.messaging.getToken()
          return {
            type: 'firebase',
            web_push_token: token
          }
        })
      }
      promise.then((data: any) => {
        this.showLoader = true
        return this.$axios.patch(process.env.API_ENDPOINT + 'user', data).then(() => {
          this.$gtm.push({event: 'push-subscribe'})
        })
      }).catch(() => {
      }).then(() => {
        let permission = ''
        if ('safari' in window) {
          // @ts-ignore
          const permissionData = window.safari.pushNotification.permission(this.webPushId)
          permission = permissionData.permission
        } else {
          permission = Notification.permission
        }

        this.showLoader = false
        switch (permission) {
          case 'default':
            this.waitPermission = false
            break
          case 'granted':
            this.isGranted = true
            break
          default:
            this.showPopup = false
        }
      })
    } catch (e) {
      this.$sentry.captureException(e)
      this.showPopup = false
    }
  }

  onMouseLeave(event) {
    const canShowWbPushPermission = this.$webPush.allowed() && this.$webPush.checkPermission() !== 'granted'
    if (event.clientY <= 0 && canShowWbPushPermission) {
      this.openPopup()
      this.beforeLeaveModalShown = true
    }
    window.document.removeEventListener('mouseleave', this.onMouseLeave)
  }

  @Watch('$route', {immediate: true})
  handleRoute(newValue) {
    if (!process.client || this.routesWhenBeforeLeaveEnabled.length === 0) {
      return false;
    }
    if (!this.beforeLeaveModalShown && this.routesWhenBeforeLeaveEnabled.includes(newValue.path)) {
      window.document.addEventListener('mouseleave', this.onMouseLeave)
    } else {
      window.document.removeEventListener('mouseleave', this.onMouseLeave)
    }
  }
}
